import React from 'react'
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { DATASET_RULES_FIELD_NAME } from 'app/constants/datasets.constants';
import { QueryViewer } from 'app/views/pages/datasets/components/DatasetRulesBuilder/DatasetRulesBuilder';
import TagsView from '../TagsView/TagsView';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(14),
      // fontWeight: theme.typography.fontWeightBold,
    },
    tag: {
      flex: 1,
      border: 'solid 1px rgba(0, 0, 0, 0.12)',
      borderRadius: '8px',
    },
  })
)

type Tag = {
  key: string
  value: string
}

interface AccordionTagsViewProps {
  tags: Tag[]
  expanded: boolean
  VISUAL_TAGS_LABELS?: { [key: string]: string }
}

export default function AccordionTagsView(props: AccordionTagsViewProps) {
  const { tags = [], VISUAL_TAGS_LABELS = {} } = props
  const classes = useStyles()
  const parseValue = (tagKey: string, tagValue: string) => {
    if (tagKey === DATASET_RULES_FIELD_NAME) {
      let rules = [];
      try {
        rules = JSON.parse(tagValue) || []
      } catch (error) {
      }

      return <div>
        {rules.map((rule: any, index: number) => {
          return (<div key={"rule-" + index}><strong>{rule.ruleName}:</strong> <QueryViewer value={rule.value} /></div>)
        })}
      </div>
    }
    return Array.isArray(tagValue) ? tagValue.join(', ') : tagValue
  }
  return (
    <div className={classes.root}>
      <Accordion defaultExpanded={props.expanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>Custom Properties</Typography>
        </AccordionSummary>
        <AccordionDetails className="flex-column">
          <TagsView tags={tags} VISUAL_TAGS_LABELS={VISUAL_TAGS_LABELS} />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
